import { IExtendedRequest } from '@mg-platform/core/core-data-access'

export class GetSalesReports {
  static readonly type = '[SalesReports] Get Sales Reports'
  constructor(public payload: Partial<IExtendedRequest>) {}
}

export class GetLaborsReports {
  static readonly type = '[SalesReports] Get Labors Reports'
  constructor(public payload: Partial<IExtendedRequest>) {}
}
